import type { GasPayload } from '@atlaskit/analytics-gas-types';

export type FilterChangeLocation = 'dropdown' | 'inline';

export const onFilterSelection = ({
	attributes,
	action,
	location,
}: {
	attributes: Record<string, unknown>;
	action: 'selected' | 'unselected';
	location: FilterChangeLocation;
}): GasPayload => ({
	eventType: 'ui',
	action,
	actionSubject: 'filter',
	actionSubjectId: 'searchDialogFilter',
	attributes: {
		...attributes,
		location,
	},
});

export const onFilterDropdown = ({
	attributes,
	action,
}: {
	attributes: Record<string, unknown>;
	action: 'open' | 'close';
}): GasPayload => ({
	eventType: 'ui',
	action,
	actionSubject: 'filterDropdown',
	actionSubjectId: 'searchDialogDropdown',
	attributes,
});

export const onFilterClear = ({
	attributes,
	location,
}: {
	attributes: Record<string, unknown>;
	location: FilterChangeLocation;
}): GasPayload => ({
	eventType: 'ui',
	action: 'clear',
	actionSubject: 'filter',
	actionSubjectId: 'searchDialogFilter',
	attributes: {
		...attributes,
		location,
	},
});
